import React, {useState, useEffect} from 'react'
import { useTexture } from '@react-three/drei'
import * as THREE from "three"
import { useSelector } from 'react-redux'
import { E_ColoriMetallo, E_ColoriTessuto } from '../Utils/enumerations'
import { codiciColoreMetallo } from '../Utils/codiciColore'
import { CodiciColoreOmbrelloni } from './CodiciColoreOmbrelloni'

// Mesh generale per gli ombrelloni
export default function OmbrelloneGenerale({nodeCorpoName, nodeTeloName, nodeExtraName, mainRotation, pos1, rot1, sc1, pos2, rot2, sc2, pos3, rot3, sc3}) {
    const coloreMetalloOmbrelloni = useSelector(state => state.uiMainMenu.coloreStrutture);  
    const coloreTessutoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.coloreTessutoOmbrelloni);   
    
    const fabricTexturesProps = useTexture({
      map: `${process.env.PUBLIC_URL}/textures/ombrelloni/Fabric_034_basecolor.jpg`,
      normalMap: `${process.env.PUBLIC_URL}/textures/ombrelloni/Fabric_034_normal.jpg`,
      roughnessMap: `${process.env.PUBLIC_URL}/textures/ombrelloni/Fabric_034_roughness.jpg`,
      aoMap: `${process.env.PUBLIC_URL}/textures/ombrelloni/Fabric_034_ambientOcclusion.jpg`,    
    })
    
    fabricTexturesProps.map.repeat.set(75, 75);
    fabricTexturesProps.normalMap.repeat.set(75, 75);
    fabricTexturesProps.roughnessMap.repeat.set(75, 75);
    fabricTexturesProps.aoMap.repeat.set(75, 75);  
    
    fabricTexturesProps.map.wrapS = fabricTexturesProps.map.wrapT = THREE.RepeatWrapping;
    fabricTexturesProps.normalMap.wrapS = fabricTexturesProps.normalMap.wrapT = THREE.RepeatWrapping;
    fabricTexturesProps.roughnessMap.wrapS = fabricTexturesProps.roughnessMap.wrapT = THREE.RepeatWrapping;
    fabricTexturesProps.aoMap.wrapS = fabricTexturesProps.aoMap.wrapT = THREE.RepeatWrapping;
  
    const [metalColor, setMetalcolor] = useState(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Nero).codice);
    const [fabricColor, setFabricColor] = useState(CodiciColoreOmbrelloni.find(el => el.label.toString() === E_ColoriTessuto.T15.toString()).value);

    useEffect(() => {  
        if (coloreMetalloOmbrelloni === E_ColoriMetallo.Antracite.toString())  setMetalcolor(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Antracite).codice);
        else if (coloreMetalloOmbrelloni === E_ColoriMetallo.Bianco.toString()) setMetalcolor(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Bianco).codice);
        // Salva il colore del tessuto degli ombrelloni
        let colorCode = CodiciColoreOmbrelloni.find(el => el.label.toString() === coloreTessutoOmbrelloni.toString()).value;
        setFabricColor(colorCode);
      }, [coloreMetalloOmbrelloni, coloreTessutoOmbrelloni]);
  
    return (
        <group dispose={null} rotation={mainRotation}>        
          <group position={pos1} rotation={rot1}>
            <mesh geometry={nodeCorpoName} scale={sc1} >  
              <meshStandardMaterial color={metalColor} roughness={0.25}/>        
            </mesh>
          </group>
          <group position={pos2} rotation={rot2}>
            <mesh geometry={nodeTeloName} scale={sc2}>
              <meshStandardMaterial {...fabricTexturesProps} color={fabricColor} roughness={1.6} toneMapped={true} side={THREE.DoubleSide} />           
            </mesh>
          </group>
          <group position={pos3} rotation={rot3}>
            <mesh geometry={nodeExtraName} scale={sc3}>
              <meshStandardMaterial color={metalColor} roughness={0.25}/>   
            </mesh>
          </group>            
        </group>         
    )
}
